module.exports = __webpack_public_path__ + "static/media/menu8-active.cd5b653f.png";